import { forwardRef } from 'react';
import { styled } from 'goober';
var TypeaheadHeight = '250px';
export var ExpressionContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        '& > .DraftEditor-root': {
            width: 'inherit',
            maxWidth: 'inherit',
            height: 'auto',
            maxHeight: '100%',
            overflowY: 'auto',
        },
        '& > .DraftEditor-content': {
            height: 'auto',
        },
    });
});
export var ExpressionButton = styled('button')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '0 25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        borderLeft: "1px solid ".concat(theme.borderColor),
        background: 'transparent',
        color: theme.colors.ui.dark,
        fontSize: ' 16px',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
        },
    });
});
export var ExpressionButtonSave = styled(ExpressionButton)(function (_a) {
    var theme = _a.theme;
    return ({
        svg: {
            fill: theme.colors.success.w700,
        },
    });
});
export var ExpressionButtonCancel = styled(ExpressionButton)(function (_a) {
    var theme = _a.theme;
    return ({
        svg: {
            fill: theme.colors.error.w500,
        },
    });
});
export var ExpressionEditorIcon = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        borderRight: "1px solid ".concat(theme.borderColor),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        height: 'calc(100% - 10px)',
        marginRight: '5px',
        svg: {
            color: theme.colors.ui.dark,
            fontSize: '18px',
        },
    });
});
export var TypeaheadContainer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        background: '#fff',
        border: "1px solid ".concat(theme.borderColor),
        borderRadius: '3px',
        boxShadow: '0px 4px 16px rgb(123 145 167 / 15%)',
        position: 'absolute',
        width: '750px',
        zIndex: 9999,
        left: '40px',
    });
});
export var TypeaheadFilter = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '10px 20px',
        borderBottom: "1px solid ".concat(theme.borderColor),
        span: {
            color: theme.colors.neutral.w700,
        },
    });
});
export var ExpList = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        height: TypeaheadHeight,
        borderRight: "1px solid ".concat(theme.borderColor),
        overflowY: 'auto',
    });
});
export var ExpListItem = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '45px',
        padding: '0px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: "1px solid ".concat(theme.colors.neutral.w300),
        '&:first-child': {
            borderTop: 'none',
        },
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
        },
        '&.active': {
            backgroundColor: theme.colors.neutral.w100,
        },
    });
});
export var TypeaheadDetails = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: TypeaheadHeight,
        padding: '10px 20px 20px',
        overflowY: 'auto',
        '>div': {
            width: '100%',
        },
        'span.title': {
            lineHeight: '18px',
            fontSize: '14px',
            fontWeight: 600,
        },
        'div.info': {
            lineHeight: 1.3,
            paddingTop: '20px',
            paddingBottom: '5px',
            fontSize: '14px',
            fontWeight: 600,
        },
        'div.example': {
            backgroundColor: theme.colors.function.w50,
            color: theme.colors.function.w500,
            padding: '10px 15px',
            borderRadius: '3px',
            fontWeight: 600,
        },
        'div.parent': {
            display: 'flex',
            alignItems: 'flex-start',
        },
        'div.description': {
            lineHeight: 1.3,
            fontSize: '14px',
            color: theme.colors.neutral.w700,
        },
    });
});
export var SaveStatus = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        right: 0,
        backgroundColor: '#fff',
        padding: '0px',
        marginRight: '15px',
        fontSize: '14px',
        zIndex: 1,
        '&.error': {
            color: theme.colors.error.w500,
        },
    });
});
